export enum URLSearchParamName {
  SearchTerm = 'searchTerm',
  FacilityMainActivity = 'facilityType',
  PollutantCode = 'pollutant',
  FirstItemIdx = 'first',
  Year = 'year',
  Placename = 'placename',
  AllOrInternational = 'country'
}
